<template>
  <order-list ref="orderList">
    <!-- <order-item ref="item" @on-update="handleUpdate"></order-item> -->
  </order-list>
</template>
<script>
import orderItem from '../base/detail'
import orderList from '../base/list'

export default {
  components: { orderItem  , orderList},
  data() {
    return {
      actions:[
        {
          title:'备注',
          key:'orderInfo.remark',
          minWidth:150,
          maxWidth:250,
          ellipsis:true,
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.view(params)
                  }
                }
              }, '查看'),
          
            ])
          }
        }
      ]
      ,
      loading: false,
      selection:[]
    }
  },
  computed: {
    
  },
  methods: {

    view({row}){
      this.$refs['item'].init( row.orderInfo.id )
    },

    handleUpdate(){
      this.$refs['orderList'].list()
    },

    $update(){
      this.$refs['orderList'].list()
    }
  }
}

</script>